import type { GetStaticProps } from 'next';

import { makeStaticPropsRequest } from '../../modules/pdf/get-static-props';
import makeDocPage from '../../modules/pdf/page';
import type { PageProps } from '../../modules/pdf/types';

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  return makeStaticPropsRequest({ slug: 'modern-slavery-statement' })();
};

const DocPage = makeDocPage<typeof getStaticProps>();
export default DocPage;
